import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TaskProfileFoldout from 'components/organisms/Foldouts/TaskProfileFoldout/TaskProfileFoldout';

const StyledEntityTaskProfileFoldout = styled(TaskProfileFoldout)`
  ${ComponentStyles}
`;

StyledEntityTaskProfileFoldout.propTypes = {
  theme: PropTypes.object
};

export default StyledEntityTaskProfileFoldout;
